<template>
    <div>
        <el-card class="form-container" shadow="never" style="margin-top: 5px">
            <el-form :inline="true" size="small" label-width="140px">
                <el-form-item label="用户Id：" label-width="180px">
                    <el-input v-model="queryOrderData.nickId"></el-input>
                </el-form-item>
                <el-col :span="8">
                    <span>操作日期：</span>
                    <el-date-picker
                        v-model="queryOrderData.createDt"
                        type="daterange"
                        :clearable="true"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </el-col>
                <el-form-item label="vip时长">
                    <el-select v-model="queryOrderData.vipType" placeholder="请选择" @change="page1()">
                        <el-option label="全部" :value=null></el-option>
                        <el-option label="永久会员-非连续订阅" :value="'永久会员-非连续订阅'"></el-option>
                        <el-option label="月度会员-非连续订阅" :value="'月度会员-非连续订阅'"></el-option>
                        <el-option label="年度会员-非连续订阅" :value="'年度会员-非连续订阅'"></el-option>
                        <el-option label="月度会员-连续订阅" :value="'月度会员-连续订阅'"></el-option>
                        <el-option label="年度会员-连续订阅" :value="'年度会员-连续订阅'"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="vip类型">
                    <el-select v-model="queryOrderData.vipTypeType" placeholder="请选择" @change="page1()">
                        <el-option label="全部" :value=null></el-option>
                        <el-option label="普通会员" :value="'普通会员'"></el-option>
                        <el-option label="免广告会员" :value="'免广告会员'"></el-option>
                        <el-option label="邀请会员" :value="'邀请会员'"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作类型">
                    <el-select v-model="queryOrderData.event" placeholder="请选择" @change="page1()">
                        <el-option label="全部" :value=null></el-option>
                        <el-option label="开" value="开"></el-option>
                        <el-option label="关" value="关"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="" class="sub-sub11">
                    <el-button type="primary" @click="searchOrder">查询</el-button>
                    <el-button type="primary" @click="exportExcel">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table border="" :data="orderList">
                <!--                <el-table-column type="index" width="50" label="序号"></el-table-column>-->
                <el-table-column label="vip时长" prop="vip_type" align="center"></el-table-column>
                <el-table-column label="vip类型" prop="vip_type_type" align="center"></el-table-column>
                <el-table-column label="操作人员" prop="account" align="center"></el-table-column>
                <el-table-column label="用户id" prop="nick_id" align="center"></el-table-column>
                <el-table-column label="操作类型" prop="event" align="center"></el-table-column>
                <el-table-column label="操作时间" prop="create_dt" align="center"></el-table-column>

            </el-table>
            <el-pagination
                style="margin-top: 5px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30,50]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </el-card>
    </div>

</template>

<script>
import settingMix from '@/utils/mix/common-setting'
import {downloadDataBook, sysVip} from "@/http/aiBookAdminApi";
import DateUtil from "@/utils/DateUtil";

export default {
    name: "AiBookSysVip",
    mixins: [settingMix],
    data() {
        return {
            page: {
                size: 30,
                page: 1,
                totalElements: null
            },
            orderList: [],
            queryOrderData: {
                "createDt": null,
                "vipType": null,
                "vipTypeType": null,
                "event": null,
                "nickId": null,
                "page": 1,
                "size": 30
            }
        }
    },
    methods: {
        handleCurrentChange(page) {
            this.page.page = page;
            this.queryOrderData.page = page;
            this.searchOrder()
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.queryOrderData.size = size;
            this.searchOrder()
        },
        page1() {
            this.page.page = 1;
            this.queryOrderData.page = 1;
        },
        searchOrder() {
            this.queryOrderData.size = this.page.size;
            this.queryOrderData.page = this.page.page;
            if (this.queryOrderData.createDt != null) {
                this.queryOrderData.createDtStart = this.queryOrderData.createDt[0] === '' ? null : this.queryOrderData.createDt[0];
                this.queryOrderData.createDtEnd = this.queryOrderData.createDt[1] === '' ? null : this.queryOrderData.createDt[1];
            } else {
                this.queryOrderData.createDtStart = null;
                this.queryOrderData.createDtEnd = null;
            }
            sysVip(this.queryOrderData).then(resp => {
                this.orderList = resp.data.info.list;
                this.page.totalElements = resp.data.info.totalElements;
            })
        },
        exportExcel() {
            let fileName = new Date().toLocaleString() + '手动开通vip记录.xlsx';
            downloadDataBook(
                '/order/sys/vip/excel',
                Object.assign(this.queryOrderData),
                fileName
            )
        },
    },
    created() {
        this.queryOrderData.createDt = DateUtil.getIntervalDate(1);
        this.searchOrder();
    },
}
</script>

<style scoped>

</style>
